declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    clarity?: (...args: any[]) => void;
  }
}

export default defineNuxtPlugin(() => {
  const GA_MEASUREMENT_ID = 'G-T42SLQH3BB';

  // Initialize dataLayer first (before script loads)
  window.dataLayer = window.dataLayer || [];

  // Define gtag function that pushes arguments array to dataLayer
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };

  // Configure Google Analytics (can be called before script loads)
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);

  // Load Google Analytics script
  const gaScript = document.createElement('script');
  gaScript.async = true;
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(gaScript);

  // --- Microsoft Clarity ---
  // Equivalent to:
  // <script type="text/javascript">
  // (function(c,l,a,r,i,t,y){
  //   c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
  //   t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
  //   y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  // })(window, document, "clarity", "script", "uje2h79rhp");
  // </script>

  (function (c: any, l: Document, a: string, r: string, i: string) {
    c[a] =
      c[a] ||
      function (...args: any[]) {
        (c[a].q = c[a].q || []).push(args);
      };
    const t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = 'https://www.clarity.ms/tag/' + i;
    const y = l.getElementsByTagName(r)[0];
    if (y && y.parentNode) {
      y.parentNode.insertBefore(t, y);
    }
  })(window, document, 'clarity', 'script', 'uje2h79rhp');
});
